import { render, staticRenderFns } from "./EliminarMosaico.vue?vue&type=template&id=28f46946&"
import script from "./EliminarMosaico.vue?vue&type=script&lang=js&"
export * from "./EliminarMosaico.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports